import React from 'react';

import css from './SectionHowPaymentsWorks.module.css';
import { H2, H3 } from '../../../components';
import classNames from 'classnames';

const items = [
  {
    title: 'HowItWorksPage.howPaymentsWork.standard.title',
    subtitle: 'HowItWorksPage.howPaymentsWork.standard.subtitle',
    importantText: 'HowItWorksPage.howPaymentsWork.standard.importantText',
    textList: [
      'HowItWorksPage.howPaymentsWork.standard.text1',
      'HowItWorksPage.howPaymentsWork.standard.text2',
      'HowItWorksPage.howPaymentsWork.standard.text3',
      'HowItWorksPage.howPaymentsWork.standard.text4',
      'HowItWorksPage.howPaymentsWork.standard.text5',
    ],
  },
  {
    title: 'HowItWorksPage.howPaymentsWork.shortNotice.title',
    subtitle: 'HowItWorksPage.howPaymentsWork.shortNotice.subtitle',
    importantText: 'HowItWorksPage.howPaymentsWork.shortNotice.importantText',
    textList: [
      'HowItWorksPage.howPaymentsWork.shortNotice.text1',
      'HowItWorksPage.howPaymentsWork.shortNotice.text2',
      'HowItWorksPage.howPaymentsWork.shortNotice.text3',
      'HowItWorksPage.howPaymentsWork.shortNotice.text4',
      'HowItWorksPage.howPaymentsWork.shortNotice.text5',
    ],
  },
  {
    title: 'HowItWorksPage.howPaymentsWork.superShortNotice.title',
    subtitle: 'HowItWorksPage.howPaymentsWork.superShortNotice.subtitle',
    importantText: 'HowItWorksPage.howPaymentsWork.superShortNotice.importantText',
    textList: [
      'HowItWorksPage.howPaymentsWork.superShortNotice.text1',
      'HowItWorksPage.howPaymentsWork.superShortNotice.text2',
      'HowItWorksPage.howPaymentsWork.superShortNotice.text3',
    ],
  },
];

const SectionHowPaymentsWork = props => {
  const { intl, className, titleClassName } = props;

  return (
    <div className={classNames(css.root, className)} id="payments">
      <H2 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorksPage.howPaymentsWork.heading' },
          { span: text => <span className={css.marketplaceText}>{text}</span> }
        )}
      </H2>
      <div className={css.subheaderWrapper}>
        <p className={css.text}>
          {intl.formatMessage(
            { id: 'HowItWorksPage.howPaymentsWork.paragraph1' },
            { span: text => <span className={css.importantText}>{text}</span> }
          )}
        </p>
        <p className={css.text}>
          {intl.formatMessage({ id: 'HowItWorksPage.howPaymentsWork.paragraph2' })}
        </p>
      </div>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <div className={css.section}>
            <H3 className={css.h3}>
              <span className={css.marketplaceText}>{`${index + 1}.`}</span>
              &nbsp;
              {intl.formatMessage(
                { id: item.title },
                { span: text => <span className={css.marketplaceText}>{text}</span> }
              )}
            </H3>
            <span className={css.subtitle}>{intl.formatMessage({ id: item.subtitle })}</span>
            <p className={css.importantText}>{intl.formatMessage({ id: item.importantText })}</p>
            <ul className={css.textList}>
              {item.textList.map(textId => (
                <li className={css.textItem} key={textId}>
                  {intl.formatMessage({ id: textId })}
                </li>
              ))}
            </ul>
          </div>
          {index !== items.length - 1 && <hr className={css.divider} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SectionHowPaymentsWork;
